import { EquipListType } from '.';

export const newEquipmentData = (
  bnNewCompanyItem: boolean,
  equipList: EquipListType[],
  nextInvNumber?: string,
) => {
  return {
    fEquipmentAddUrl: bnNewCompanyItem ? 'new' : 'exist',
    fEquipmentAttachmentId: -1,
    fEquipmentAttachmentName: '',
    fEquipmentAttachment: undefined,
    fEquipmentCompEqFK: bnNewCompanyItem
      ? -1
      : equipList[0].fComEquipmentId || -1,
    fEquipmentDeliveryDate: null,
    fEquipmentReturnDate: null,
    fEquipmentExpirationDate: bnNewCompanyItem
      ? null
      : equipList[0].fComEquipmentExpirationDate || null,
    fEquipmentInfo: '',
    fEquipmentId: undefined,
    fEquipmentInvNumber: bnNewCompanyItem
      ? nextInvNumber || ''
      : equipList[0].fComEquipmentInvNumber || '',
    fEquipmentItem: '',
    fEquipmentType: bnNewCompanyItem
      ? ''
      : equipList[0].fComEquipmentType || '',
    bnNewCompanyItem: bnNewCompanyItem,
  };
};
